import {Widget, defineCustomWidget} from '@acng/frontend-stargazer';
import {CTX_VALUE} from '@acng/frontend-relativity/minify';
import {TypeError} from '@acng/frontend-bounty';

import {ctxMessageComposer} from 'acng/messenger/context/message-composer.js';

import {coreFeature} from '../config/feature.js';
import {smileys} from '../factory/smileyList.js';

defineCustomWidget(
  coreFeature,
  'onsw-smileys',
  class extends Widget {
    /**
     * @param {import("@acng/frontend-stargazer").TemplateUtility<{repeat: HTMLImageElement}>} template
     */
    render(template) {
      const {
        elements: {repeat},
      } = template;

      template.repeatElement(repeat, smileys, (smiley) => {
        repeat.alt = smiley.key;
        repeat.src = smiley.getUrl();
        repeat.title = smiley.key;
      });

      this.onclick = (ev) => {
        if (ev.target instanceof HTMLImageElement) {
          ctxMessageComposer[CTX_VALUE](this).body += ev.target.alt;
        } else {
          throw TypeError();
        }
      };
    }
  }
);
